//VNEXT-348: KLW - Created an enum to hold values to be used in other components
export enum WorkflowEnum {
    WORKFLOW_ACTION = 'workflow action',
    WORKFLOW_STATE = 'workflow state',
    WORKFLOW = 'workflow'

}
